import { friendlyKeyNameToPhysicalKeyCode } from './friendly-key-name-to-physical-key-code';
import type { KeyStep, ParsedHotkey } from './types';

export function parseHotkey(hotkey: string, usePhysicalKeys: boolean): ParsedHotkey {
  // Check if it's a sequence (contains >)
  if (hotkey.includes('>')) {
    const steps = hotkey.split('>').map((step) => parseKeyStep(step.trim(), usePhysicalKeys));
    return { type: 'sequence', steps } as const;
  }

  // Single combination
  return { type: 'combination', steps: parseKeyStep(hotkey, usePhysicalKeys) } as const;
}

function parseKeyStep(step: string, usePhysicalKeys: boolean): KeyStep {
  const parts = step.split('+').map((p) => p.trim().toLowerCase());
  const modifiers = {
    meta: false,
    ctrl: false,
    shift: false,
    alt: false,
  };

  // Extract modifiers and main key
  let mainKey = '';
  for (const part of parts) {
    if (['meta', 'cmd', 'command'].includes(part)) {
      modifiers.meta = true;
    } else if (['ctrl', 'control'].includes(part)) {
      modifiers.ctrl = true;
    } else if (part === 'shift') {
      modifiers.shift = true;
    } else if (['alt', 'option'].includes(part)) {
      modifiers.alt = true;
    } else {
      mainKey = part;
    }
  }

  // Convert to physical key if needed
  if (usePhysicalKeys) {
    mainKey = friendlyKeyNameToPhysicalKeyCode(mainKey);
  }

  return { key: mainKey, modifiers };
}
